class CartSummaryDropup extends HTMLElement {
  constructor() {
    super();
    this._onOutsideClick = this.handleOutsideClick.bind(this);
    this._onComponentClick = this.handleComponentClick.bind(this);
    this._onComponentKeydown = this.handleComponentKeydown.bind(this);
  }

  connectedCallback() {
    // Event delegation survives inner HTML replacement by custom.js
    this.addEventListener('click', this._onComponentClick);
    this.addEventListener('keydown', this._onComponentKeydown);
    document.addEventListener('click', this._onOutsideClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onComponentClick);
    this.removeEventListener('keydown', this._onComponentKeydown);
    document.removeEventListener('click', this._onOutsideClick);
  }

  handleComponentClick(e) {
    const header = e.target.closest('.dropup-header');
    if (!header) return;

    e.preventDefault();
    e.stopPropagation();
    this.toggle();
  }

  handleComponentKeydown(e) {
    const header = e.target.closest('.dropup-header');

    if (header && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      e.stopPropagation();
      this.toggle();
      return;
    }

    if (e.key === 'Escape' && this.hasAttribute('open')) {
      e.preventDefault();
      this.setOpen(false);
      this.querySelector('.dropup-header')?.focus();
    }
  }

  setOpen(isOpen) {
    const header = this.querySelector('.dropup-header');
    const content = this.querySelector('.dropup-content');

    if (isOpen) {
      this.setAttribute('open', '');
    } else {
      this.removeAttribute('open');
    }

    header?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    content?.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  }

  toggle() {
    this.setOpen(!this.hasAttribute('open'));
  }

  handleOutsideClick(e) {
    if (this.hasAttribute('open') && !this.contains(e.target)) {
      this.setOpen(false);
    }
  }
}

if (!customElements.get('cart-summary-dropup')) {
  customElements.define('cart-summary-dropup', CartSummaryDropup);
}
